exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".video-block>div[data-v-bfd41fd6]{position:relative;height:0;padding-bottom:56.25%;overflow:hidden}.video-block>div iframe[data-v-bfd41fd6]{border:none}", "", {"version":3,"sources":["D:/Relocus/Dev/_Archive/Sota/sota/src/components/blocks/VideoBlock.vue"],"names":[],"mappings":"AACA,kCACE,kBAAmB,AACnB,SAAU,AACV,sBAAuB,AACvB,eAAiB,CAClB,AACD,yCACI,WAAa,CAChB","file":"VideoBlock.vue","sourcesContent":["\n.video-block > div[data-v-bfd41fd6] {\n  position: relative;\n  height: 0;\n  padding-bottom: 56.25%;\n  overflow: hidden;\n}\n.video-block > div iframe[data-v-bfd41fd6] {\n    border: none;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":true,"sourceMap":true}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-bfd41fd6","scoped":true,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js?{"sourceMap":true}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/blocks/VideoBlock.vue
// module id = 100
// module chunks = 0 3 4